import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  tagsPostList: null
};

// ************************* Fetch Tags Post List *************************
const fetchTagsPostListStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTagsPostListSuccess = (state = INITIAL_STATE, action) => {
  // console.log('action: ', action);
  return { ...state, tagsPostList: action.tagsPostList, loading: false };
};

const fetchTagsPostListFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_TAGS_POST_LIST_START]: fetchTagsPostListStart,
  [Types.FETCH_TAGS_POST_LIST_FAILURE]: fetchTagsPostListFailure,
  [Types.FETCH_TAGS_POST_LIST_SUCCESS]: fetchTagsPostListSuccess
};

// Create and Export Reducer
export const tagsPostListReducer = createReducer(INITIAL_STATE, HANDLERS);
